import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import EcoBanner, { EcoBannerProps } from 'eco-design/sections/eco-banner-card';
import { gsap } from 'gsap';
import { memo, useEffect, useRef } from 'react';
import styles from './index.module.scss';

const DownIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 8 8" fill="none">
        <path
            d="M4.00469 0.789062V3.98906V7.18906M4.00469 7.18906L0.804688 3.98906M4.00469 7.18906L7.20469 3.98906"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

const BANNER_IMAGES = {
    PC: 'https://websiteoss.ecoflow.com/upload/image/1748500285067/2560-KV.jpg',
    H5: 'https://websiteoss.ecoflow.com/upload/image/1748500284872/1023_KV.jpg',
};

const CERTIFICATIONS = [
    { src: 'https://websiteoss.ecoflow.com/upload/image/1748138315896/logo1.png' },
    { src: 'https://websiteoss.ecoflow.com/upload/image/1748138315536/logo2.png' },
    { src: 'https://websiteoss.ecoflow.com/upload/image/1748138315715/logo3.png' },
    { src: 'https://websiteoss.ecoflow.com/upload/image/1748138315366/logo4.png' },
];

const BannerTips = memo(() => {
    const arrowRef = useRef(null);
    const { t } = useLang('theProduct.BannerA');

    useEffect(() => {
        if (!arrowRef.current) return undefined;

        const tl = gsap.timeline({
            repeat: -1,
            defaults: { ease: 'power2.inOut' },
        });

        tl.set(arrowRef.current, { y: -9, opacity: 0 })
            .to(arrowRef.current, {
                y: 0,
                opacity: 1,
                duration: 0.3, // 20% 阶段
                ease: 'none',
            })
            .to(arrowRef.current, {
                y: 0,
                opacity: 1,
                duration: 0.5, // 50% 阶段
            })
            .to(arrowRef.current, {
                y: 10,
                opacity: 0,
                duration: 0.6, // 30% 阶段
                ease: 'none',
            });

        return () => {
            tl.kill();
        };
    }, []);

    return (
        <>
            <div className="banner-tips">
                <div className="banner-tips-text">{t('tips1')}</div>
                <div className={styles['banner-tips-icon']}>
                    {/* <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.79995 16.0001C4.79995 9.81448 9.81436 4.80007 16 4.80007C22.1855 4.80007 27.2 9.81448 27.2 16.0001C27.2 22.1857 22.1855 27.2001 16 27.2001C9.81436 27.2001 4.79995 22.1857 4.79995 16.0001ZM16 3.20007C8.93071 3.20007 3.19995 8.93083 3.19995 16.0001C3.19995 23.0693 8.93071 28.8001 16 28.8001C23.0692 28.8001 28.8 23.0693 28.8 16.0001C28.8 8.93083 23.0692 3.20007 16 3.20007ZM15.9993 8.53357C16.4411 8.53357 16.7993 8.89174 16.7993 9.33357V19.4027L20.7676 15.4344C21.08 15.122 21.5865 15.122 21.899 15.4344C22.2114 15.7468 22.2114 16.2533 21.899 16.5658L16.5656 21.8991C16.4731 21.9916 16.3635 22.0568 16.247 22.0945C16.169 22.1199 16.0858 22.1336 15.9993 22.1336C15.7674 22.1336 15.5586 22.0349 15.4125 21.8773L10.1009 16.5658C9.78851 16.2533 9.78851 15.7468 10.1009 15.4344C10.4134 15.122 10.9199 15.122 11.2323 15.4344L15.1993 19.4014L15.1993 9.33357C15.1993 8.89174 15.5575 8.53357 15.9993 8.53357Z"
                        fill="white"
                    />
                </svg> */}
                    <div className="icon">
                        <div className="arrow-down" ref={arrowRef}>
                            <DownIcon />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
});

BannerTips.displayName = 'BannerTips';

const BannerA = () => {
    const { t } = useLang('theProduct.BannerA');
    const { locale } = getLocal();

    const dataA: EcoBannerProps = {
        layout: 'top-center',
        pc: BANNER_IMAGES.PC,
        pad: BANNER_IMAGES.PC,
        h5: BANNER_IMAGES.H5,
        label: t('label'),
        labelColor: '#D11504',
        titleColor: '#ffffff',
        descColor: '#ffffff',
        title: t('desc'),
        desc: t('title'),

        childrenB: <BannerTips />,
    };

    return (
        <div className={styles.comp}>
            <EcoBanner {...dataA} />
            <div className="certifications-container">
                <div className="certifications">
                    {CERTIFICATIONS.map((item, index) => (
                        <img
                            key={index}
                            src={item.src}
                            alt={`certification-${index + 1}`}
                            style={{
                                maxHeight: '82px',
                                width: 'auto',
                                objectFit: 'contain',
                            }}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default BannerA;
